export enum SpinnerType {
  DEFAULT = 'default',
  HOURGLASS = 'hourglass',
}

export enum SpinnerSize {
  SMALL = 'small',
  MID = 'mid',
  LARGE = 'large',
}

export enum SpinnerBackgroundColor {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum SpinnerColor {
  PRIMARY = 'primary',
  GRAY = 'gray',
  LIGHT = 'light',
}
